import { render, staticRenderFns } from "./FormsList.vue?vue&type=template&id=4d9b9547&"
import script from "./FormsList.vue?vue&type=script&lang=js&"
export * from "./FormsList.vue?vue&type=script&lang=js&"
import style0 from "./FormsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports